import { useState } from "react";

import {emailIcon, githubIcon, linkedinIcon, mobileIcon, contactBook} from '../Files/icons/index.js';
import {LeftIcon, RightIcon} from "../Files/svg_icons/index.js";


export default function RightDetailsNav (props) {

    const personalDetails = props.personalDetails;

    const {name, mobile, linkedin, github, email} = personalDetails;

    const [profilesSliderActive, setProfilesSliderActive] = useState(false);
    const [profileDetailActive, setProfileDetailActive] = useState(false);

    const copyData = (clickedData) => {

        window.open(clickedData, "_blank");
    }

    return (
        <>
            <section className="right-nav">

                <div className="slider-container">


                {
                    profilesSliderActive && 

                    <ul className="icon-with-data">

                        {
                            profileDetailActive && <li>
                            {
                                profileDetailActive && <strong className="data-only">{name} </strong>
                            }
                            
                        </li>
                        }
                        
                        
                        <li>
                            <a href= {`mailto:${email}`} target="_black">
                                <img className="icon-only" src={emailIcon} alt="email" /> 
                            </a>
                            {
                                profileDetailActive && <button onClick={() => copyData(`mailto:${email}`)} className="data-only">{email} </button>
                            }
                            
                        </li>
                        <li>
                            <a href={`tel:${mobile}`}>
                                <img className="icon-only" src={mobileIcon} alt="phone" /> 
                            </a>
                            {
                                profileDetailActive && <button onClick={() => copyData(`tel:${mobile}`)} className="data-only">{mobile} </button>
                            }
                            
                        </li>
                        <li>
                            <a href={`https://${linkedin}`} target="_black">
                                <img className="icon-only" src={linkedinIcon} alt="linkedin" /> 
                            </a>
                            {
                                profileDetailActive && <button onClick={() => copyData(`https://${linkedin}`)} className="data-only">{linkedin} </button>
                            }
                            
                        </li>
                        <li>
                            <a href={github} target="_black">
                                <img className="icon-only" src={githubIcon} alt="github" /> 
                            </a>
                            {
                                profileDetailActive && <button onClick={() => copyData(github)} className="data-only">{github} </button>
                            }
                            
                        </li>
                            
                            
                        <li className="slider-arrow">
                            <button 
                                className="arrow-left-right" 
                                onClick={() => setProfileDetailActive(!profileDetailActive)}
                                title={profileDetailActive ? "Collapse" : "Expand"}
                            >
                                <img src={profileDetailActive ? RightIcon : LeftIcon} alt="arrow left" style={{height: "auto"}} /> 
                            </button>
                        </li>

                    </ul>
                        
                }

                <div style={{display:"flex", justifyContent: "right"}}>

                    <button className="contact-detail-button" title="contact details" onClick={() => setProfilesSliderActive(!profilesSliderActive)}>
                        <img src={contactBook} alt="contact details" />
                    </button>

                </div>

                </div>
                
                
            </section>
        </>
    );
}

